import React, { useEffect, useState, useRef } from 'react';

import { applyTypography, BaseButton, useT } from '@repo/common';

import { ReactComponent as SearchIcon } from '@repo/common/assets/icons/20px/icon_20px_search.svg';
import { ReactComponent as HamburgerMenuIcon } from '@repo/common/assets/icons/20px/icon_20px_hamburger-menu.svg';

const TXT_SEARCH_KEY = 'b16';

/**
 * onOpenMenu 를 넘기면 모바일 변형: 좌측 햄버거(상태 드로어 열기) + 입력, 검색은 Enter 로 실행.
 */
const AdminSearchBar = ({ onSearch, defaultValue, onOpenMenu }) => {
  const t = useT();
  const inputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState(defaultValue || '');
  const [isFocusedSearch, setIsFocusedSearch] = useState(false);

  useEffect(() => {
    setSearchTerm(defaultValue || '');
  }, [defaultValue]);

  const handleSearch = () => {
    onSearch?.(searchTerm.trim());
  };

  if (onOpenMenu) {
    return (
      <div className='flex w-full max-w-[600px] items-center gap-2 rounded-[30px] bg-grayscale-gray00 p-2 shadow-3'>
        <button
          type='button'
          aria-label={t('Open job menu', '공고 메뉴 열기')}
          onClick={onOpenMenu}
          className='flex shrink-0 items-center justify-center p-2 text-icon-primary'
        >
          <HamburgerMenuIcon className='size-5' />
        </button>
        <input
          ref={inputRef}
          type='search'
          enterKeyHint='search'
          placeholder={t(
            'Job, company, location, keyword',
            '공고, 회사, 지역, 키워드',
          )}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSearch();
              inputRef.current?.blur();
            }
          }}
          className='min-w-0 flex-[1_0_0] truncate bg-transparent typo-b14 text-text-primary placeholder:text-text-placeholder focus:outline-none [&::-webkit-search-cancel-button]:hidden'
        />
      </div>
    );
  }

  return (
    <div className='flex justify-center'>
      <div className='w-full'>
        <div
          className={`relative flex items-center rounded-[30px] bg-grayscale-gray00 shadow-3
                  border-[1.6px] transition-colors
                  ${
                    isFocusedSearch || searchTerm
                      ? 'border-grayscale-gray07'
                      : 'border-transparent'
                  }`}
        >
          <input
            ref={inputRef}
            type='text'
            placeholder={t(
              'Search by job title, company, location, or keyword',
              '공고 제목, 회사, 지역 또는 키워드로 검색',
            )}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSearch();
              }
            }}
            onFocus={() => setIsFocusedSearch(true)}
            onBlur={() => setIsFocusedSearch(false)}
            className={`${applyTypography(
              TXT_SEARCH_KEY,
            )} w-full h-[53px] py-[10px] pl-6 pr-[60px] soft-60 text-text-primary focus:outline-none rounded-[30px]`}
          />
          <BaseButton
            type='primary'
            icon={<SearchIcon />}
            bgclass='absolute right-2 h-10 w-10 rounded-full'
            onClick={handleSearch}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminSearchBar;
